document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".el-sold-progress");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;

        // Only animate when visible, and only once
        if (!entry.isIntersecting || el.classList.contains("has-animated"))
          return;

        el.classList.add("has-animated");

        const fill = el.querySelector(".el-sold-progress__fill");
        const percentText = el.querySelector(".el-sold-progress__percent");

        if (!fill || !percentText) return;

        const target = parseInt(el.dataset.percentage || "0", 10);
        const duration = parseInt(el.dataset.duration || "1200", 10);
        const steps = parseInt(el.dataset.step || "30", 10);

        fill.style.width = "0%";
        percentText.textContent = "0%";

        setTimeout(() => {
          fill.style.width = `${target}%`;

          let current = 0;
          const stepValue = target / steps;
          const intervalTime = duration / steps;

          const counter = setInterval(() => {
            current += stepValue;

            if (current >= target) {
              current = target;
              clearInterval(counter);

              // Stop watching this element after it has animated
              observer.unobserve(el);
            }

            percentText.textContent = `${Math.round(current)}%`;
          }, intervalTime);
        }, 100);
      });
    },
    {
      threshold: 0.5,
    },
  );

  elements.forEach((el) => observer.observe(el));
});
